// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/customer/customer.v2.proto (package no.jotta.openapi.customer.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { BytesValue, Message as Message$1, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Country } from "../country_pb.js";
import { GetPathRequest_Sort } from "../file/file.v2_pb.js";
import { ContentRef } from "../ref_pb.js";
import { Language } from "../language_pb.js";
import { WopiConsent } from "../wopi_pb.js";
import { Avatar } from "../avatar_pb.js";
import { Challenges, Credentials } from "../credentials_pb.js";
import { BoolValue, StringValue } from "../../protobuf/wrappers_pb.js";
/**
 * @generated from enum no.jotta.openapi.customer.v2.AccountType
 */
export var AccountType;
(function (AccountType) {
    /**
     * @generated from enum value: UNKNOWN_ACCOUNT_TYPE = 0;
     */
    AccountType[AccountType["UNKNOWN_ACCOUNT_TYPE"] = 0] = "UNKNOWN_ACCOUNT_TYPE";
    /**
     * A regular customer with personal subscription, i.e. not part of a business subscription.
     *
     * @generated from enum value: CONSUMER = 1;
     */
    AccountType[AccountType["CONSUMER"] = 1] = "CONSUMER";
    /**
     * A business user whom subscription is managed (and payed) by the company account.
     *
     * @generated from enum value: BUSINESS_USER = 2;
     */
    AccountType[AccountType["BUSINESS_USER"] = 2] = "BUSINESS_USER";
    /**
     * A business user who has privileges to manage the business account and business subscription.
     *
     * @generated from enum value: BUSINESS_ADMIN = 3;
     */
    AccountType[AccountType["BUSINESS_ADMIN"] = 3] = "BUSINESS_ADMIN";
    /**
     * A family user whom subscription is managed (and payed) by the family owner
     *
     * @generated from enum value: FAMILY_MEMBER = 4;
     */
    AccountType[AccountType["FAMILY_MEMBER"] = 4] = "FAMILY_MEMBER";
    /**
     * A family user who has privileges to manage the family account and family subscription.
     *
     * @generated from enum value: FAMILY_OWNER = 5;
     */
    AccountType[AccountType["FAMILY_OWNER"] = 5] = "FAMILY_OWNER";
})(AccountType || (AccountType = {}));
// Retrieve enum metadata with: proto3.getEnumType(AccountType)
proto3.util.setEnumType(AccountType, "no.jotta.openapi.customer.v2.AccountType", [
    { no: 0, name: "UNKNOWN_ACCOUNT_TYPE" },
    { no: 1, name: "CONSUMER" },
    { no: 2, name: "BUSINESS_USER" },
    { no: 3, name: "BUSINESS_ADMIN" },
    { no: 4, name: "FAMILY_MEMBER" },
    { no: 5, name: "FAMILY_OWNER" },
]);
/**
 * @generated from enum no.jotta.openapi.customer.v2.SubscriptionType
 */
export var SubscriptionType;
(function (SubscriptionType) {
    /**
     * @generated from enum value: UNKNOWN_SUBSCRIPTION_TYPE = 0;
     */
    SubscriptionType[SubscriptionType["UNKNOWN_SUBSCRIPTION_TYPE"] = 0] = "UNKNOWN_SUBSCRIPTION_TYPE";
    /**
     * Free subscription, i.e. no payments of any kind
     *
     * @generated from enum value: FREE = 1;
     */
    SubscriptionType[SubscriptionType["FREE"] = 1] = "FREE";
    /**
     * Subscription with limited storage and unlimited number of devices
     *
     * @generated from enum value: LIMITED = 2;
     */
    SubscriptionType[SubscriptionType["LIMITED"] = 2] = "LIMITED";
    /**
     * Subscription with unlimited storage, but limited number of devices
     *
     * @generated from enum value: UNLIMITED = 3;
     */
    SubscriptionType[SubscriptionType["UNLIMITED"] = 3] = "UNLIMITED";
    /**
     * Subscription with unlimited storage and unlimited number of devices
     *
     * @generated from enum value: UUNLIMITED = 4;
     */
    SubscriptionType[SubscriptionType["UUNLIMITED"] = 4] = "UUNLIMITED";
})(SubscriptionType || (SubscriptionType = {}));
// Retrieve enum metadata with: proto3.getEnumType(SubscriptionType)
proto3.util.setEnumType(SubscriptionType, "no.jotta.openapi.customer.v2.SubscriptionType", [
    { no: 0, name: "UNKNOWN_SUBSCRIPTION_TYPE" },
    { no: 1, name: "FREE" },
    { no: 2, name: "LIMITED" },
    { no: 3, name: "UNLIMITED" },
    { no: 4, name: "UUNLIMITED" },
]);
/**
 * @generated from enum no.jotta.openapi.customer.v2.LockCause
 */
export var LockCause;
(function (LockCause) {
    /**
     * @generated from enum value: UNKNOWN_LOCK_CAUSE = 0;
     */
    LockCause[LockCause["UNKNOWN_LOCK_CAUSE"] = 0] = "UNKNOWN_LOCK_CAUSE";
    /**
     * @generated from enum value: PAYMENT_LOCK = 1;
     */
    LockCause[LockCause["PAYMENT_LOCK"] = 1] = "PAYMENT_LOCK";
    /**
     * @generated from enum value: EXPIRE_LOCK = 2;
     */
    LockCause[LockCause["EXPIRE_LOCK"] = 2] = "EXPIRE_LOCK";
    /**
     * @generated from enum value: BUSINESS_LOCK = 3;
     */
    LockCause[LockCause["BUSINESS_LOCK"] = 3] = "BUSINESS_LOCK";
    /**
     * @generated from enum value: BREACH_LOCK = 4;
     */
    LockCause[LockCause["BREACH_LOCK"] = 4] = "BREACH_LOCK";
})(LockCause || (LockCause = {}));
// Retrieve enum metadata with: proto3.getEnumType(LockCause)
proto3.util.setEnumType(LockCause, "no.jotta.openapi.customer.v2.LockCause", [
    { no: 0, name: "UNKNOWN_LOCK_CAUSE" },
    { no: 1, name: "PAYMENT_LOCK" },
    { no: 2, name: "EXPIRE_LOCK" },
    { no: 3, name: "BUSINESS_LOCK" },
    { no: 4, name: "BREACH_LOCK" },
]);
/**
 * @generated from enum no.jotta.openapi.customer.v2.PhotoState
 */
export var PhotoState;
(function (PhotoState) {
    /**
     * @generated from enum value: UNKNOWN_PHOTO_STATE = 0;
     */
    PhotoState[PhotoState["UNKNOWN_PHOTO_STATE"] = 0] = "UNKNOWN_PHOTO_STATE";
    /**
     * @generated from enum value: NOT_ACTIVE = 1;
     */
    PhotoState[PhotoState["NOT_ACTIVE"] = 1] = "NOT_ACTIVE";
    /**
     * @generated from enum value: QUEUED = 2;
     */
    PhotoState[PhotoState["QUEUED"] = 2] = "QUEUED";
    /**
     * @generated from enum value: INIT_IMPORT = 3;
     */
    PhotoState[PhotoState["INIT_IMPORT"] = 3] = "INIT_IMPORT";
    /**
     * @generated from enum value: IMPORTING = 4;
     */
    PhotoState[PhotoState["IMPORTING"] = 4] = "IMPORTING";
    /**
     * @generated from enum value: IMPORT_FINISHED = 5;
     */
    PhotoState[PhotoState["IMPORT_FINISHED"] = 5] = "IMPORT_FINISHED";
})(PhotoState || (PhotoState = {}));
// Retrieve enum metadata with: proto3.getEnumType(PhotoState)
proto3.util.setEnumType(PhotoState, "no.jotta.openapi.customer.v2.PhotoState", [
    { no: 0, name: "UNKNOWN_PHOTO_STATE" },
    { no: 1, name: "NOT_ACTIVE" },
    { no: 2, name: "QUEUED" },
    { no: 3, name: "INIT_IMPORT" },
    { no: 4, name: "IMPORTING" },
    { no: 5, name: "IMPORT_FINISHED" },
]);
/**
 * @generated from enum no.jotta.openapi.customer.v2.QuotaState
 */
export var QuotaState;
(function (QuotaState) {
    /**
     * @generated from enum value: QUOTA_STATE_UNKNOWN = 0;
     */
    QuotaState[QuotaState["QUOTA_STATE_UNKNOWN"] = 0] = "QUOTA_STATE_UNKNOWN";
    /**
     * @generated from enum value: VALID = 1;
     */
    QuotaState[QuotaState["VALID"] = 1] = "VALID";
    /**
     * @generated from enum value: SOON_FULL = 2;
     */
    QuotaState[QuotaState["SOON_FULL"] = 2] = "SOON_FULL";
    /**
     * @generated from enum value: FULL = 3;
     */
    QuotaState[QuotaState["FULL"] = 3] = "FULL";
})(QuotaState || (QuotaState = {}));
// Retrieve enum metadata with: proto3.getEnumType(QuotaState)
proto3.util.setEnumType(QuotaState, "no.jotta.openapi.customer.v2.QuotaState", [
    { no: 0, name: "QUOTA_STATE_UNKNOWN" },
    { no: 1, name: "VALID" },
    { no: 2, name: "SOON_FULL" },
    { no: 3, name: "FULL" },
]);
/**
 * @generated from enum no.jotta.openapi.customer.v2.InviteState
 */
export var InviteState;
(function (InviteState) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    InviteState[InviteState["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: INVITE_CREATED = 1;
     */
    InviteState[InviteState["INVITE_CREATED"] = 1] = "INVITE_CREATED";
    /**
     * @generated from enum value: INVITE_SENT = 2;
     */
    InviteState[InviteState["INVITE_SENT"] = 2] = "INVITE_SENT";
    /**
     * @generated from enum value: INVITE_ACCEPTED = 3;
     */
    InviteState[InviteState["INVITE_ACCEPTED"] = 3] = "INVITE_ACCEPTED";
    /**
     * @generated from enum value: INVITE_CANCELED = 4;
     */
    InviteState[InviteState["INVITE_CANCELED"] = 4] = "INVITE_CANCELED";
})(InviteState || (InviteState = {}));
// Retrieve enum metadata with: proto3.getEnumType(InviteState)
proto3.util.setEnumType(InviteState, "no.jotta.openapi.customer.v2.InviteState", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "INVITE_CREATED" },
    { no: 2, name: "INVITE_SENT" },
    { no: 3, name: "INVITE_ACCEPTED" },
    { no: 4, name: "INVITE_CANCELED" },
]);
/**
 * @generated from enum no.jotta.openapi.customer.v2.TerminationSurveyCategory
 */
export var TerminationSurveyCategory;
(function (TerminationSurveyCategory) {
    /**
     * @generated from enum value: SURVEY_CATEGORY_UNKNOWN = 0;
     */
    TerminationSurveyCategory[TerminationSurveyCategory["SURVEY_CATEGORY_UNKNOWN"] = 0] = "SURVEY_CATEGORY_UNKNOWN";
})(TerminationSurveyCategory || (TerminationSurveyCategory = {}));
// Retrieve enum metadata with: proto3.getEnumType(TerminationSurveyCategory)
proto3.util.setEnumType(TerminationSurveyCategory, "no.jotta.openapi.customer.v2.TerminationSurveyCategory", [
    { no: 0, name: "SURVEY_CATEGORY_UNKNOWN" },
]);
/**
 * @generated from message no.jotta.openapi.customer.v2.BrandingInfo
 */
export class BrandingInfo extends Message$1 {
    /**
     * @generated from field: string brand_code = 1;
     */
    brandCode = "";
    /**
     * @generated from field: string brand_name = 2;
     */
    brandName = "";
    /**
     * @generated from field: string customer_group_code = 3;
     */
    customerGroupCode = "";
    /**
     * @generated from field: string customer_group_name = 4;
     */
    customerGroupName = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.BrandingInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "brand_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "brand_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "customer_group_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new BrandingInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrandingInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrandingInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrandingInfo, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.Business
 */
export class Business extends Message$1 {
    /**
     * @generated from field: string name = 1;
     */
    name = "";
    /**
     * @generated from field: string org_no = 2;
     */
    orgNo = "";
    /**
     * @generated from field: no.jotta.openapi.Country country = 3;
     */
    country = Country.UNKNOWN_COUNTRY;
    /**
     * @generated from field: int64 max_user_count = 4;
     */
    maxUserCount = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.Business";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "org_no", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "country", kind: "enum", T: proto3.getEnumType(Country) },
        { no: 4, name: "max_user_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new Business().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Business().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Business().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Business, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.Family
 */
export class Family extends Message$1 {
    /**
     * @generated from field: string name = 1;
     */
    name = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.Family";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Family().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Family().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Family().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Family, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.AccountLock
 */
export class AccountLock extends Message$1 {
    /**
     * @generated from field: bool is_write_locked = 1;
     */
    isWriteLocked = false;
    /**
     * @generated from field: bool is_read_locked = 2;
     */
    isReadLocked = false;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.LockCause cause = 3;
     */
    cause = LockCause.UNKNOWN_LOCK_CAUSE;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.AccountLock";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "is_write_locked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 2, name: "is_read_locked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 3, name: "cause", kind: "enum", T: proto3.getEnumType(LockCause) },
    ]);
    static fromBinary(bytes, options) {
        return new AccountLock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AccountLock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AccountLock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AccountLock, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.IntercomConfig
 */
export class IntercomConfig extends Message$1 {
    /**
     * @generated from field: string web_hash = 1;
     */
    webHash = "";
    /**
     * @generated from field: string android_hash = 2;
     */
    androidHash = "";
    /**
     * @generated from field: string ios_hash = 3;
     */
    iosHash = "";
    /**
     * @generated from field: string app_id = 4;
     */
    appId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.IntercomConfig";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "web_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "android_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "ios_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "app_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new IntercomConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntercomConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntercomConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntercomConfig, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.WebSettings
 */
export class WebSettings extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.customer.v2.WebSettings.ViewMode view_mode = 1;
     */
    viewMode = WebSettings_ViewMode.LIST;
    /**
     * @generated from field: no.jotta.openapi.file.v2.GetPathRequest.Sort sort_mode = 2;
     */
    sortMode = GetPathRequest_Sort.UNKNOWN;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.WebSettings";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "view_mode", kind: "enum", T: proto3.getEnumType(WebSettings_ViewMode) },
        { no: 2, name: "sort_mode", kind: "enum", T: proto3.getEnumType(GetPathRequest_Sort) },
    ]);
    static fromBinary(bytes, options) {
        return new WebSettings().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WebSettings().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WebSettings().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WebSettings, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.customer.v2.WebSettings.ViewMode
 */
export var WebSettings_ViewMode;
(function (WebSettings_ViewMode) {
    /**
     * @generated from enum value: LIST = 0;
     */
    WebSettings_ViewMode[WebSettings_ViewMode["LIST"] = 0] = "LIST";
    /**
     * @generated from enum value: GRID = 1;
     */
    WebSettings_ViewMode[WebSettings_ViewMode["GRID"] = 1] = "GRID";
})(WebSettings_ViewMode || (WebSettings_ViewMode = {}));
// Retrieve enum metadata with: proto3.getEnumType(WebSettings_ViewMode)
proto3.util.setEnumType(WebSettings_ViewMode, "no.jotta.openapi.customer.v2.WebSettings.ViewMode", [
    { no: 0, name: "LIST" },
    { no: 1, name: "GRID" },
]);
/**
 * @generated from message no.jotta.openapi.customer.v2.UserSettings
 */
export class UserSettings extends Message$1 {
    /**
     * @generated from field: bool excessive_trash_warning_enabled = 1;
     */
    excessiveTrashWarningEnabled = false;
    /**
     * @generated from field: bool app_activity_notifications_enabled = 2;
     */
    appActivityNotificationsEnabled = false;
    /**
     * @generated from field: bool email_activity_notifications_enabled = 3;
     */
    emailActivityNotificationsEnabled = false;
    /**
     * @generated from field: bool newsletter_enabled = 4;
     */
    newsletterEnabled = false;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.WebSettings web_settings = 5;
     */
    webSettings;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.UserSettings";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "excessive_trash_warning_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 2, name: "app_activity_notifications_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 3, name: "email_activity_notifications_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 4, name: "newsletter_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 5, name: "web_settings", kind: "message", T: WebSettings },
    ]);
    static fromBinary(bytes, options) {
        return new UserSettings().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UserSettings().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UserSettings().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UserSettings, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.Message
 */
export class Message extends Message$1 {
    /**
     * @generated from field: string localized_title = 4;
     */
    localizedTitle = "";
    /**
     * @generated from field: string localized_message = 1;
     */
    localizedMessage = "";
    /**
     * @generated from field: no.jotta.openapi.customer.v2.Message.Importance importance = 6;
     */
    importance = Message_Importance.UNKNOWN_IMPORTANCE;
    /**
     * @generated from field: optional no.jotta.openapi.ContentRef ref = 2;
     */
    ref;
    /**
     * @generated from field: optional string encoded_content_ref = 3;
     */
    encodedContentRef;
    /**
     * @generated from field: optional string localized_button_text = 5;
     */
    localizedButtonText;
    /**
     * @generated from field: optional no.jotta.openapi.customer.v2.Message.Type type = 7;
     */
    type;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.Message";
    static fields = proto3.util.newFieldList(() => [
        { no: 4, name: "localized_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 1, name: "localized_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "importance", kind: "enum", T: proto3.getEnumType(Message_Importance) },
        { no: 2, name: "ref", kind: "message", T: ContentRef, opt: true },
        { no: 3, name: "encoded_content_ref", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 5, name: "localized_button_text", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 7, name: "type", kind: "enum", T: proto3.getEnumType(Message_Type), opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new Message().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Message().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Message().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Message, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.customer.v2.Message.Importance
 */
export var Message_Importance;
(function (Message_Importance) {
    /**
     * can/should be safely ignored
     *
     * @generated from enum value: UNKNOWN_IMPORTANCE = 0;
     */
    Message_Importance[Message_Importance["UNKNOWN_IMPORTANCE"] = 0] = "UNKNOWN_IMPORTANCE";
    /**
     * @generated from enum value: CRITICAL = 1;
     */
    Message_Importance[Message_Importance["CRITICAL"] = 1] = "CRITICAL";
    /**
     * @generated from enum value: WARNING = 2;
     */
    Message_Importance[Message_Importance["WARNING"] = 2] = "WARNING";
    /**
     * @generated from enum value: INFO = 3;
     */
    Message_Importance[Message_Importance["INFO"] = 3] = "INFO";
})(Message_Importance || (Message_Importance = {}));
// Retrieve enum metadata with: proto3.getEnumType(Message_Importance)
proto3.util.setEnumType(Message_Importance, "no.jotta.openapi.customer.v2.Message.Importance", [
    { no: 0, name: "UNKNOWN_IMPORTANCE" },
    { no: 1, name: "CRITICAL" },
    { no: 2, name: "WARNING" },
    { no: 3, name: "INFO" },
]);
/**
 * @generated from enum no.jotta.openapi.customer.v2.Message.Type
 */
export var Message_Type;
(function (Message_Type) {
    /**
     * @generated from enum value: UNKNOWN_MESSAGE_TYPE = 0;
     */
    Message_Type[Message_Type["UNKNOWN_MESSAGE_TYPE"] = 0] = "UNKNOWN_MESSAGE_TYPE";
    /**
     * @generated from enum value: OUT_OF_STORAGE = 1;
     */
    Message_Type[Message_Type["OUT_OF_STORAGE"] = 1] = "OUT_OF_STORAGE";
})(Message_Type || (Message_Type = {}));
// Retrieve enum metadata with: proto3.getEnumType(Message_Type)
proto3.util.setEnumType(Message_Type, "no.jotta.openapi.customer.v2.Message.Type", [
    { no: 0, name: "UNKNOWN_MESSAGE_TYPE" },
    { no: 1, name: "OUT_OF_STORAGE" },
]);
/**
 * @generated from message no.jotta.openapi.customer.v2.Customer
 */
export class Customer extends Message$1 {
    /**
     * @generated from field: string username = 1;
     */
    username = "";
    /**
     * @generated from field: string email = 2;
     */
    email = "";
    /**
     * @generated from field: string full_name = 3;
     */
    fullName = "";
    /**
     * @generated from field: optional string phone_number = 4;
     */
    phoneNumber;
    /**
     * @generated from field: bool phone_number_verified = 5;
     */
    phoneNumberVerified = false;
    /**
     * Deprecated: use country enum instead
     *
     * @generated from field: string country_code = 6;
     */
    countryCode = "";
    /**
     * @generated from field: no.jotta.openapi.Country country = 29;
     */
    country = Country.UNKNOWN_COUNTRY;
    /**
     * Deprecated: use language enum type instead.
     *
     * @generated from field: string language_code = 7;
     */
    languageCode = "";
    /**
     * @generated from field: no.jotta.openapi.Language language = 19;
     */
    language = Language.UNKNOWN_LANGUAGE;
    /**
     * The total number of bytes this customer has storage in his/her account
     *
     * @generated from field: int64 usage_bytes = 8;
     */
    usageBytes = protoInt64.zero;
    /**
     * The total number of bytes this customer is allowed to store in his/her account. Unlimited storage = -1
     *
     * @generated from field: int64 quota_bytes = 9;
     */
    quotaBytes = protoInt64.zero;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.PhotoState photo_state = 18;
     */
    photoState = PhotoState.UNKNOWN_PHOTO_STATE;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.AccountType account_type = 10;
     */
    accountType = AccountType.UNKNOWN_ACCOUNT_TYPE;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.SubscriptionType subscription_type = 11;
     */
    subscriptionType = SubscriptionType.UNKNOWN_SUBSCRIPTION_TYPE;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.BrandingInfo branding_info = 12;
     */
    brandingInfo;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.AccountLock account_lock = 13;
     */
    accountLock;
    /**
     * @generated from field: optional no.jotta.openapi.customer.v2.IntercomConfig intercom = 14;
     */
    intercom;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.UserSettings user_settings = 15;
     */
    userSettings;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.Business business = 16;
     */
    business;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.Family family = 17;
     */
    family;
    /**
     * @generated from field: no.jotta.openapi.WopiConsent wopi_consent = 20;
     */
    wopiConsent = WopiConsent.UNKNOWN;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.Customer.TFAType tfa_type = 21;
     */
    tfaType = Customer_TFAType.NONE;
    /**
     * @generated from field: repeated no.jotta.openapi.customer.v2.Message messages = 22;
     */
    messages = [];
    /**
     * promote_upgrade is used for showing upgrade option in menus
     *
     * @generated from field: bool promote_upgrade = 23;
     */
    promoteUpgrade = false;
    /**
     * Display button for terminating account. Some labels may require the customer to do termination at the partner's site.
     *
     * @generated from field: bool can_terminate_account = 24;
     */
    canTerminateAccount = false;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.QuotaState quota = 25;
     */
    quota = QuotaState.QUOTA_STATE_UNKNOWN;
    /**
     * @generated from field: no.jotta.openapi.customer.v2.Customer.OnBoarding onboarding = 26;
     */
    onboarding;
    /**
     * @generated from field: no.jotta.openapi.Avatar avatar = 28;
     */
    avatar;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.Customer";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 5, name: "phone_number_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 6, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 29, name: "country", kind: "enum", T: proto3.getEnumType(Country) },
        { no: 7, name: "language_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 19, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
        { no: 8, name: "usage_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 9, name: "quota_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 18, name: "photo_state", kind: "enum", T: proto3.getEnumType(PhotoState) },
        { no: 10, name: "account_type", kind: "enum", T: proto3.getEnumType(AccountType) },
        { no: 11, name: "subscription_type", kind: "enum", T: proto3.getEnumType(SubscriptionType) },
        { no: 12, name: "branding_info", kind: "message", T: BrandingInfo },
        { no: 13, name: "account_lock", kind: "message", T: AccountLock },
        { no: 14, name: "intercom", kind: "message", T: IntercomConfig, opt: true },
        { no: 15, name: "user_settings", kind: "message", T: UserSettings },
        { no: 16, name: "business", kind: "message", T: Business },
        { no: 17, name: "family", kind: "message", T: Family },
        { no: 20, name: "wopi_consent", kind: "enum", T: proto3.getEnumType(WopiConsent) },
        { no: 21, name: "tfa_type", kind: "enum", T: proto3.getEnumType(Customer_TFAType) },
        { no: 22, name: "messages", kind: "message", T: Message, repeated: true },
        { no: 23, name: "promote_upgrade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 24, name: "can_terminate_account", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 25, name: "quota", kind: "enum", T: proto3.getEnumType(QuotaState) },
        { no: 26, name: "onboarding", kind: "message", T: Customer_OnBoarding },
        { no: 28, name: "avatar", kind: "message", T: Avatar },
    ]);
    static fromBinary(bytes, options) {
        return new Customer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Customer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Customer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Customer, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.customer.v2.Customer.TFAType
 */
export var Customer_TFAType;
(function (Customer_TFAType) {
    /**
     * @generated from enum value: NONE = 0;
     */
    Customer_TFAType[Customer_TFAType["NONE"] = 0] = "NONE";
    /**
     * @generated from enum value: TOTP = 1;
     */
    Customer_TFAType[Customer_TFAType["TOTP"] = 1] = "TOTP";
    /**
     * @generated from enum value: SMS = 2;
     */
    Customer_TFAType[Customer_TFAType["SMS"] = 2] = "SMS";
})(Customer_TFAType || (Customer_TFAType = {}));
// Retrieve enum metadata with: proto3.getEnumType(Customer_TFAType)
proto3.util.setEnumType(Customer_TFAType, "no.jotta.openapi.customer.v2.Customer.TFAType", [
    { no: 0, name: "NONE" },
    { no: 1, name: "TOTP" },
    { no: 2, name: "SMS" },
]);
/**
 * @generated from message no.jotta.openapi.customer.v2.Customer.OnBoarding
 */
export class Customer_OnBoarding extends Message$1 {
    /**
     * @generated from field: map<string, bool> status = 1;
     */
    status = {};
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.Customer.OnBoarding";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "status", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 8 /* ScalarType.BOOL */ } },
    ]);
    static fromBinary(bytes, options) {
        return new Customer_OnBoarding().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Customer_OnBoarding().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Customer_OnBoarding().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Customer_OnBoarding, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.GetCustomerRequest
 */
export class GetCustomerRequest extends Message$1 {
    /**
     * Optional parameter to override language for the @Message localization.
     * This is mainly useful for apps that have a different language from the customer.language,
     * such as mobile apps that follow the OS language instead of the customer.language.
     *
     * @generated from field: no.jotta.openapi.Language language = 1;
     */
    language = Language.UNKNOWN_LANGUAGE;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.GetCustomerRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    ]);
    static fromBinary(bytes, options) {
        return new GetCustomerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.GetCustomerResponse
 */
export class GetCustomerResponse extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.customer.v2.Customer customer = 1;
     */
    customer;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.GetCustomerResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "customer", kind: "message", T: Customer },
    ]);
    static fromBinary(bytes, options) {
        return new GetCustomerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.LanguageValue
 */
export class LanguageValue extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.Language language = 1;
     */
    language = Language.UNKNOWN_LANGUAGE;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.LanguageValue";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    ]);
    static fromBinary(bytes, options) {
        return new LanguageValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LanguageValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LanguageValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LanguageValue, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.PatchCustomerRequest
 */
export class PatchCustomerRequest extends Message$1 {
    /**
     * Optional parameter to override language for the customer @Message localization.
     * This is mainly useful for apps that have a different language from the customer.language,
     * such as mobile apps that follow the OS language instead of the customer.language.
     *
     * @generated from field: no.jotta.openapi.Language response_language = 1;
     */
    responseLanguage = Language.UNKNOWN_LANGUAGE;
    /**
     * @generated from field: no.jotta.openapi.Credentials credentials = 18;
     */
    credentials;
    /**
     * @generated from field: no.jotta.protobuf.StringValue email = 19;
     */
    email;
    /**
     * @generated from field: no.jotta.protobuf.StringValue password = 20;
     */
    password;
    /**
     * @generated from field: no.jotta.protobuf.StringValue phone_number = 21;
     */
    phoneNumber;
    /**
     * @generated from field: no.jotta.protobuf.BoolValue excessive_trash_warning_enabled = 10;
     */
    excessiveTrashWarningEnabled;
    /**
     * @generated from field: no.jotta.protobuf.BoolValue app_activity_notifications_enabled = 11;
     */
    appActivityNotificationsEnabled;
    /**
     * @generated from field: no.jotta.protobuf.BoolValue email_activity_notifications_enabled = 12;
     */
    emailActivityNotificationsEnabled;
    /**
     * @generated from field: no.jotta.protobuf.BoolValue newsletter_enabled = 13;
     */
    newsletterEnabled;
    /**
     * @generated from field: no.jotta.protobuf.StringValue name = 14;
     */
    name;
    /**
     * @generated from field: no.jotta.protobuf.StringValue country_code = 15;
     */
    countryCode;
    /**
     * Deprecated: use enum language
     * no.jotta.protobuf.StringValue language_code = 16;
     * Optional paramter to change the language of the account
     *
     * @generated from field: no.jotta.openapi.customer.v2.LanguageValue language = 17;
     */
    language;
    /**
     * @generated from field: google.protobuf.BytesValue profile_photo = 22;
     */
    profilePhoto;
    /**
     * @generated from field: optional no.jotta.openapi.customer.v2.WebSettings web_settings = 23;
     */
    webSettings;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.PatchCustomerRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "response_language", kind: "enum", T: proto3.getEnumType(Language) },
        { no: 18, name: "credentials", kind: "message", T: Credentials },
        { no: 19, name: "email", kind: "message", T: StringValue },
        { no: 20, name: "password", kind: "message", T: StringValue },
        { no: 21, name: "phone_number", kind: "message", T: StringValue },
        { no: 10, name: "excessive_trash_warning_enabled", kind: "message", T: BoolValue },
        { no: 11, name: "app_activity_notifications_enabled", kind: "message", T: BoolValue },
        { no: 12, name: "email_activity_notifications_enabled", kind: "message", T: BoolValue },
        { no: 13, name: "newsletter_enabled", kind: "message", T: BoolValue },
        { no: 14, name: "name", kind: "message", T: StringValue },
        { no: 15, name: "country_code", kind: "message", T: StringValue },
        { no: 17, name: "language", kind: "message", T: LanguageValue },
        { no: 22, name: "profile_photo", kind: "message", T: BytesValue },
        { no: 23, name: "web_settings", kind: "message", T: WebSettings, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new PatchCustomerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchCustomerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchCustomerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchCustomerRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.PatchCustomerResponse
 */
export class PatchCustomerResponse extends Message$1 {
    /**
     * @generated from oneof no.jotta.openapi.customer.v2.PatchCustomerResponse.response
     */
    response = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.PatchCustomerResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "message", T: Challenges, oneof: "response" },
        { no: 2, name: "customer", kind: "message", T: Customer, oneof: "response" },
    ]);
    static fromBinary(bytes, options) {
        return new PatchCustomerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchCustomerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchCustomerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchCustomerResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.FamilyInvite
 */
export class FamilyInvite extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.customer.v2.InviteState state = 1;
     */
    state = InviteState.UNKNOWN;
    /**
     * The address this invitation was sent to, e.g. an email or telephone number.
     *
     * @generated from field: string send_address_deprecated = 2;
     */
    sendAddressDeprecated = "";
    /**
     * @generated from oneof no.jotta.openapi.customer.v2.FamilyInvite.send_address
     */
    sendAddress = { case: undefined };
    /**
     * The username of the user that sent (created) this invite.
     *
     * @generated from field: string from_username = 3;
     */
    fromUsername = "";
    /**
     * The username of the user this invite was accepted by. Only present after accepting invite.
     *
     * @generated from field: string to_username = 4;
     */
    toUsername = "";
    /**
     * The full name of the user this invite was accepted by. Only present after accepting invite.
     *
     * @generated from field: string to_user_fullname = 5;
     */
    toUserFullname = "";
    /**
     * The avatar the user this invite was accepted by. Only present after accepting invite.
     *
     * @generated from field: no.jotta.openapi.Avatar to_avatar = 9;
     */
    toAvatar;
    /**
     * @generated from field: string invite_code = 6;
     */
    inviteCode = "";
    /**
     * @generated from field: string invite_link = 7;
     */
    inviteLink = "";
    /**
     * @generated from field: int64 fs_usage_bytes = 8;
     */
    fsUsageBytes = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.FamilyInvite";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(InviteState) },
        { no: 2, name: "send_address_deprecated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 10, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "send_address" },
        { no: 11, name: "sms", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "send_address" },
        { no: 3, name: "from_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "to_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "to_user_fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 9, name: "to_avatar", kind: "message", T: Avatar },
        { no: 6, name: "invite_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "invite_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 8, name: "fs_usage_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new FamilyInvite().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FamilyInvite().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FamilyInvite().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FamilyInvite, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.CreateInvite
 */
export class CreateInvite extends Message$1 {
    /**
     * @generated from oneof no.jotta.openapi.customer.v2.CreateInvite.invite
     */
    invite = { case: undefined };
    /**
     * @generated from field: string first_name = 3;
     */
    firstName = "";
    /**
     * @generated from field: string last_name = 4;
     */
    lastName = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.CreateInvite";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "email_invite", kind: "message", T: CreateInvite_EmailInvite, oneof: "invite" },
        { no: 2, name: "sms_invite", kind: "message", T: CreateInvite_SmsInvite, oneof: "invite" },
        { no: 3, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CreateInvite().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateInvite().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateInvite().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateInvite, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.CreateInvite.EmailInvite
 */
export class CreateInvite_EmailInvite extends Message$1 {
    /**
     * if email already belongs to a user account
     *
     * @generated from field: string email = 1;
     */
    email = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.CreateInvite.EmailInvite";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CreateInvite_EmailInvite().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateInvite_EmailInvite().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateInvite_EmailInvite().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateInvite_EmailInvite, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.CreateInvite.SmsInvite
 */
export class CreateInvite_SmsInvite extends Message$1 {
    /**
     * phonenumber must be a fully qualified phone number with an IDD prefix, i.e. '004781549300'.
     *
     * @generated from field: string phonenumber = 1;
     */
    phonenumber = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.CreateInvite.SmsInvite";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "phonenumber", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CreateInvite_SmsInvite().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateInvite_SmsInvite().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateInvite_SmsInvite().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateInvite_SmsInvite, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.SendFamilyInviteRequest
 */
export class SendFamilyInviteRequest extends Message$1 {
    /**
     * invite as email or sms.
     *
     * @generated from field: no.jotta.openapi.customer.v2.CreateInvite create_invite = 1;
     */
    createInvite;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.SendFamilyInviteRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "create_invite", kind: "message", T: CreateInvite },
    ]);
    static fromBinary(bytes, options) {
        return new SendFamilyInviteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SendFamilyInviteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SendFamilyInviteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SendFamilyInviteRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.SendFamilyInviteResponse
 */
export class SendFamilyInviteResponse extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.customer.v2.InviteState state = 1;
     */
    state = InviteState.UNKNOWN;
    /**
     * @generated from field: string invite_code = 2;
     */
    inviteCode = "";
    /**
     * @generated from field: string invite_link = 3;
     */
    inviteLink = "";
    /**
     * @generated from field: string send_address = 4;
     */
    sendAddress = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.SendFamilyInviteResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(InviteState) },
        { no: 2, name: "invite_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "invite_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "send_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new SendFamilyInviteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SendFamilyInviteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SendFamilyInviteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SendFamilyInviteResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.GetFamilyRequest
 */
export class GetFamilyRequest extends Message$1 {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.GetFamilyRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetFamilyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFamilyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFamilyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFamilyRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.GetFamilyResponse
 */
export class GetFamilyResponse extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.customer.v2.Family family = 1;
     */
    family;
    /**
     * @generated from field: int64 max_invites_count = 2;
     */
    maxInvitesCount = protoInt64.zero;
    /**
     * @generated from field: int64 family_quota_bytes = 3;
     */
    familyQuotaBytes = protoInt64.zero;
    /**
     * @generated from field: int64 total_usage_bytes = 4;
     */
    totalUsageBytes = protoInt64.zero;
    /**
     * @generated from field: int64 owner_usage_bytes = 5;
     */
    ownerUsageBytes = protoInt64.zero;
    /**
     * @generated from field: repeated no.jotta.openapi.customer.v2.FamilyInvite invites = 6;
     */
    invites = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.GetFamilyResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "family", kind: "message", T: Family },
        { no: 2, name: "max_invites_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 3, name: "family_quota_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 4, name: "total_usage_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 5, name: "owner_usage_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 6, name: "invites", kind: "message", T: FamilyInvite, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetFamilyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFamilyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFamilyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFamilyResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.ChangeEmailRequest
 */
export class ChangeEmailRequest extends Message$1 {
    /**
     * the new email in lowercase
     *
     * @generated from field: string new_email = 1;
     */
    newEmail = "";
    /**
     * account password
     *
     * @generated from field: string password = 2;
     */
    password = "";
    /**
     * a 2fa token code. required if account has 2FA enabled.
     *
     * @generated from field: string totp_code = 3;
     */
    totpCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.ChangeEmailRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "new_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "totp_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ChangeEmailRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeEmailRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeEmailRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeEmailRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.ChangeEmailResponse
 */
export class ChangeEmailResponse extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.customer.v2.ChangeEmailResponse.ChangeEmailResult result = 1;
     */
    result = ChangeEmailResponse_ChangeEmailResult.CHANGE_EMAIL_UNKNOWN;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.ChangeEmailResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(ChangeEmailResponse_ChangeEmailResult) },
    ]);
    static fromBinary(bytes, options) {
        return new ChangeEmailResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeEmailResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeEmailResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeEmailResponse, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.customer.v2.ChangeEmailResponse.ChangeEmailResult
 */
export var ChangeEmailResponse_ChangeEmailResult;
(function (ChangeEmailResponse_ChangeEmailResult) {
    /**
     * @generated from enum value: CHANGE_EMAIL_UNKNOWN = 0;
     */
    ChangeEmailResponse_ChangeEmailResult[ChangeEmailResponse_ChangeEmailResult["CHANGE_EMAIL_UNKNOWN"] = 0] = "CHANGE_EMAIL_UNKNOWN";
    /**
     * @generated from enum value: CHANGE_EMAIL_OK = 1;
     */
    ChangeEmailResponse_ChangeEmailResult[ChangeEmailResponse_ChangeEmailResult["CHANGE_EMAIL_OK"] = 1] = "CHANGE_EMAIL_OK";
    /**
     * @generated from enum value: CHANGE_EMAIL_REQUIRES_OTP = 2;
     */
    ChangeEmailResponse_ChangeEmailResult[ChangeEmailResponse_ChangeEmailResult["CHANGE_EMAIL_REQUIRES_OTP"] = 2] = "CHANGE_EMAIL_REQUIRES_OTP";
    /**
     * @generated from enum value: CHANGE_EMAIL_BAD_CREDENTIALS = 3;
     */
    ChangeEmailResponse_ChangeEmailResult[ChangeEmailResponse_ChangeEmailResult["CHANGE_EMAIL_BAD_CREDENTIALS"] = 3] = "CHANGE_EMAIL_BAD_CREDENTIALS";
})(ChangeEmailResponse_ChangeEmailResult || (ChangeEmailResponse_ChangeEmailResult = {}));
// Retrieve enum metadata with: proto3.getEnumType(ChangeEmailResponse_ChangeEmailResult)
proto3.util.setEnumType(ChangeEmailResponse_ChangeEmailResult, "no.jotta.openapi.customer.v2.ChangeEmailResponse.ChangeEmailResult", [
    { no: 0, name: "CHANGE_EMAIL_UNKNOWN" },
    { no: 1, name: "CHANGE_EMAIL_OK" },
    { no: 2, name: "CHANGE_EMAIL_REQUIRES_OTP" },
    { no: 3, name: "CHANGE_EMAIL_BAD_CREDENTIALS" },
]);
/**
 * @generated from message no.jotta.openapi.customer.v2.TerminateAccountRequest
 */
export class TerminateAccountRequest extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.Credentials credentials = 1;
     */
    credentials;
    /**
     * @generated from field: optional no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey survey = 2;
     */
    survey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.TerminateAccountRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "credentials", kind: "message", T: Credentials },
        { no: 2, name: "survey", kind: "message", T: TerminateAccountRequest_Survey, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new TerminateAccountRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminateAccountRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminateAccountRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminateAccountRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey
 */
export class TerminateAccountRequest_Survey extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.customer.v2.TerminationSurveyCategory category = 1;
     */
    category = TerminationSurveyCategory.SURVEY_CATEGORY_UNKNOWN;
    /**
     * @generated from field: string comment = 2;
     */
    comment = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.TerminateAccountRequest.Survey";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "category", kind: "enum", T: proto3.getEnumType(TerminationSurveyCategory) },
        { no: 2, name: "comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new TerminateAccountRequest_Survey().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminateAccountRequest_Survey().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminateAccountRequest_Survey().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminateAccountRequest_Survey, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.TerminateAccountResponse
 */
export class TerminateAccountResponse extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.Challenges challenges = 1;
     */
    challenges;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.TerminateAccountResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "message", T: Challenges },
    ]);
    static fromBinary(bytes, options) {
        return new TerminateAccountResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminateAccountResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminateAccountResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminateAccountResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.DowngradeAccountRequest
 */
export class DowngradeAccountRequest extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.Credentials credentials = 1;
     */
    credentials;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.DowngradeAccountRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "credentials", kind: "message", T: Credentials },
    ]);
    static fromBinary(bytes, options) {
        return new DowngradeAccountRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DowngradeAccountRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DowngradeAccountRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DowngradeAccountRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.DowngradeAccountResponse
 */
export class DowngradeAccountResponse extends Message$1 {
    /**
     * @generated from field: no.jotta.openapi.Challenges challenges = 1;
     */
    challenges;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.DowngradeAccountResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "message", T: Challenges },
    ]);
    static fromBinary(bytes, options) {
        return new DowngradeAccountResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DowngradeAccountResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DowngradeAccountResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DowngradeAccountResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest
 */
export class RevokeFamilyInviteRequest extends Message$1 {
    /**
     * @generated from field: string invite_code = 1;
     */
    inviteCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.RevokeFamilyInviteRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "invite_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new RevokeFamilyInviteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevokeFamilyInviteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevokeFamilyInviteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevokeFamilyInviteRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse
 */
export class RevokeFamilyInviteResponse extends Message$1 {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.RevokeFamilyInviteResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new RevokeFamilyInviteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevokeFamilyInviteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevokeFamilyInviteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevokeFamilyInviteResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest
 */
export class AcceptFamilyInviteRequest extends Message$1 {
    /**
     * @generated from field: string invite_code = 1;
     */
    inviteCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.AcceptFamilyInviteRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "invite_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new AcceptFamilyInviteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptFamilyInviteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptFamilyInviteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptFamilyInviteRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse
 */
export class AcceptFamilyInviteResponse extends Message$1 {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.AcceptFamilyInviteResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new AcceptFamilyInviteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptFamilyInviteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptFamilyInviteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptFamilyInviteResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.SetOnboardingTaskRequest
 */
export class SetOnboardingTaskRequest extends Message$1 {
    /**
     * @generated from field: string task_id = 1;
     */
    taskId = "";
    /**
     * @generated from field: bool state = 2;
     */
    state = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.SetOnboardingTaskRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "state", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new SetOnboardingTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOnboardingTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOnboardingTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOnboardingTaskRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.SetOnboardingTaskResponse
 */
export class SetOnboardingTaskResponse extends Message$1 {
    /**
     * @generated from field: map<string, bool> status = 1;
     */
    status = {};
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.SetOnboardingTaskResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "status", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 8 /* ScalarType.BOOL */ } },
    ]);
    static fromBinary(bytes, options) {
        return new SetOnboardingTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOnboardingTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOnboardingTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOnboardingTaskResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.ApproveLoginRequest
 */
export class ApproveLoginRequest extends Message$1 {
    /**
     * @generated from field: string login_code = 1;
     */
    loginCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.ApproveLoginRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "login_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ApproveLoginRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveLoginRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveLoginRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveLoginRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.ApproveLoginResponse
 */
export class ApproveLoginResponse extends Message$1 {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.ApproveLoginResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ApproveLoginResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveLoginResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveLoginResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveLoginResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.CreateIdentityLinkRequest
 */
export class CreateIdentityLinkRequest extends Message$1 {
    /**
     * @generated from field: string federated_token = 1;
     */
    federatedToken = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.CreateIdentityLinkRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "federated_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CreateIdentityLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIdentityLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIdentityLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIdentityLinkRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.customer.v2.CreateIdentityLinkResponse
 */
export class CreateIdentityLinkResponse extends Message$1 {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.customer.v2.CreateIdentityLinkResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CreateIdentityLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIdentityLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIdentityLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIdentityLinkResponse, a, b);
    }
}
